import script from "./AIcon.vue?vue&type=script&lang=js"
export * from "./AIcon.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__